import React from 'react';

import Field, { hasDataInFields } from '../../containers/PageBuilder/Field';
import SectionContainer from '../../containers/PageBuilder/SectionBuilder/SectionContainer';

import { absaetze } from '../contentBits';
import { fixAbsatz, istWegzulassen } from '../textFixes';
import { labelFuer, LIFECYCLE, LIFECYCLE_WHY } from '../rules';
import gem from '../salesPage.module.css';
import css from './SectionRules.module.css';

/**
 * FairwayBid: Regeln und der Lebenslauf einer Anfrage.
 *
 * Der Abschnitt war rund 1.500 Zeichen Fließtext. Darin steckten aber keine
 * Absätze, sondern drei Regeln und ein Ablauf mit drei Phasen. Als Text muss
 * man ihn lesen, als Phasen sieht man ihn – deshalb hier eine Zeitleiste
 * statt eines Textblocks.
 *
 * Die Begründung, warum die Fristen begrenzt sind, steht aufgeklappt hinter
 * einer Zeile. Nicht gelöscht, nur nicht im Weg: Wer sie sucht, findet sie;
 * wer nur wissen will, wie lange eine Anfrage läuft, sieht drei Phasen.
 *
 * Die Regeltexte kommen weiter aus der Console; die Überschriften darüber
 * sind Etiketten (siehe rules.js), die Fristen Produktverhalten.
 */
const SectionRules = props => {
  const {
    sectionId,
    className,
    rootClassName,
    title,
    description,
    appearance,
    callToAction,
    blocks = [],
    options,
  } = props;

  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };
  const hasHeaderFields = hasDataInFields([title, callToAction], fieldOptions);

  const regeln = absaetze(description?.content)
    .filter(a => !istWegzulassen(a, sectionId))
    .map(a => fixAbsatz(a, sectionId));

  const blockTitel = blocks?.[0]?.title?.content || 'Wie lange eine Anfrage sichtbar ist';

  return (
    <SectionContainer
      id={sectionId}
      className={className}
      rootClassName={rootClassName}
      appearance={appearance}
      options={fieldOptions}
    >
      {hasHeaderFields ? (
        <header className={gem.header}>
          <Field data={title} className={gem.headTitle} options={fieldOptions} />
          <span className={gem.rule} aria-hidden="true" />
          <Field data={callToAction} options={fieldOptions} />
        </header>
      ) : null}

      <div className={gem.wrap}>
        <div className={css.rules}>
          {regeln.map(a => {
            const label = labelFuer(a);
            return (
              <article key={a.slice(0, 40)} className={css.rule}>
                {label ? <h3 className={css.ruleLabel}>{label}</h3> : null}
                <p className={css.ruleText}>{a}</p>
              </article>
            );
          })}
        </div>

        <h3 className={css.lifecycleTitle}>{blockTitel}</h3>
        <ol className={css.phases}>
          {LIFECYCLE.map(p => (
            <li key={p.key} className={css.phase}>
              <span className={css.phaseSpan}>{p.span}</span>
              <h4 className={css.phaseTitle}>{p.title}</h4>
              <p className={css.phaseText}>{p.text}</p>
            </li>
          ))}
        </ol>

        {/*
          Die Begruendung ist wichtig, aber nicht auf den ersten Blick noetig.
          Aufklappbar statt geloescht: Wer sie sucht, findet sie.
        */}
        <details className={css.why}>
          <summary className={css.whySummary}>
            <span className={css.whyLine}>{LIFECYCLE_WHY.frage}</span>
          </summary>
          <p className={css.whyText}>{LIFECYCLE_WHY.antwort}</p>
        </details>
      </div>
    </SectionContainer>
  );
};

export default SectionRules;
